;(function() {
  'use strict'

  Controller.$inject = ["$q", "$scope", "$element", "$animate", "$state", "StateFactory", "glUtils", "glAnalytics", "glDialog", "glToast", "featureService", "userService", "subscriberService", "projectService", "surveyService", "surveyServiceNext", "accountService", "channelService", "projectResourceService", "uacService", "publicationService", "projectTrackerService", "cloudinaryService", "projectSortService", "glPrefs"];
  angular.module('app.project').controller('Project', Controller)

  /* @ngInject */
  function Controller(
    $q,
    $scope,
    $element,
    $animate,
    $state,
    StateFactory,
    glUtils,
    glAnalytics,
    glDialog,
    glToast,
    featureService,
    userService,
    subscriberService,
    projectService,
    surveyService,
    surveyServiceNext,
    accountService,
    channelService,
    projectResourceService,
    uacService,
    publicationService,
    projectTrackerService,
    cloudinaryService,
    projectSortService,
    glPrefs
  ) {
    var ctrl = this

    var EXPLORE_TRACKERS_URL = 'https://solution.glowfeed.com/brand-tracking'
    var FILTER_LABEL = {
      trackers: 'Trackers',
      surveys: 'Surveys',
      resources: 'Resources',
      reports: 'Reports',
    }
    var CAP = { card: 4, list: 5 }
    var VIEWS = ['card', 'list']
    var SURVEY_FIELDS = {
      updated: 'updatedAt',
      created: 'createdAt',
      name: function(survey) {
        return survey.reference || survey.title
      },
    }
    var ITEM_FIELDS = {
      updated: 'updatedAt',
      created: 'createdAt',
      name: 'name',
    }
    var prefs = glPrefs.create('projectFolder')
    var subscriberId = subscriberService.getSubscriber().id
    var sortPrefKey = 'sort:' + subscriberId
    var viewPrefKey = 'view:' + subscriberId

    ctrl.state = new StateFactory(['loading', 'loaded', 'error'])

    ctrl.exploreTrackersUrl = EXPLORE_TRACKERS_URL
    ctrl.newSurvey = newSurvey
    ctrl.openSurvey = openSurvey
    ctrl.editProject = editProject
    ctrl.archiveProject = projectService.promptAndArchive
    ctrl.unarchiveProject = projectService.promptAndUnarchive
    ctrl.archive = archive
    ctrl.unArchive = unArchive
    ctrl.clone = clone
    ctrl.move = move
    ctrl.addResource = addResource
    ctrl.editResource = editResource
    ctrl.deleteResource = deleteResource
    ctrl.showTrackerEditor = showTrackerEditor
    ctrl.isTypeHidden = publicationService.isTypeHidden
    ctrl.setFilter = setFilter
    ctrl.capClass = capClass
    ctrl.setSort = setSort
    ctrl.setView = setView

    init()

    function init() {
      $animate.enabled($element, false)
      ctrl.id = $state.params.id
      ctrl.isSSR = userService.isSSR()
      ctrl.subscriber = subscriberService.getSubscriber()
      ctrl.state.loading()
      ctrl.canUseProjectResources = featureService.canUseProjectResources()
      ctrl.sortOptions = _.reject(projectSortService.OPTIONS, {
        value: 'recentResponses',
      })
      ctrl.sort = readSort()
      useView(readView())
      useFilter($state.params.filter || 'all')

      loadProject()
        .then(function() {
          return $q.all([
            loadSurveys(),
            loadReports(),
            loadTrackers(),
            loadResources(),
          ])
        })
        .then(function() {
          order()
          $scope.$watch('$ctrl.project.imageUrl', setImageStyle)
          $scope.$watch(getCountsKey, setSections)
          ctrl.state.loaded()
        })
        .catch(function() {
          ctrl.state.error()
        })
    }

    function loadProject() {
      return projectService.get(ctrl.id).then(function(project) {
        ctrl.project = project
      })
    }

    function loadSurveys() {
      return surveyService
        .getByProject(ctrl.project.id)
        .then(function(surveys) {
          ctrl.archived = _.remove(surveys, { isArchived: true })
          ctrl.surveys = surveys
        })
    }

    function loadReports() {
      return publicationService
        .getByProject(ctrl.project.id)
        .then(function(reports) {
          ctrl.reports = reports
        })
    }

    function loadTrackers() {
      return projectTrackerService
        .getByProject(ctrl.project.id)
        .then(function(trackers) {
          ctrl.trackers = trackers
        })
    }

    function loadResources() {
      if (!ctrl.canUseProjectResources) return $q.resolve()
      ctrl.resourceLoader = projectResourceService.getByProject(ctrl.project.id)
      return ctrl.resourceLoader.settled
    }

    function getResources() {
      var resources = ctrl.resourceLoader && ctrl.resourceLoader.resources
      return _.reject(resources, 'isRemoved')
    }

    function countResources() {
      return getResources().length
    }

    function getCountsKey() {
      return [
        ctrl.trackers.length,
        ctrl.surveys.length,
        ctrl.archived.length,
        countResources(),
        ctrl.reports.length,
      ].join()
    }

    function setSections() {
      ctrl.counts = {
        trackers: ctrl.trackers.length,
        surveys: ctrl.surveys.length,
        resources: countResources(),
        reports: ctrl.reports.length,
      }
      var sections = ctrl.counts.trackers
        ? ['trackers', 'surveys']
        : ['surveys', 'trackers']
      if (ctrl.canUseProjectResources) sections.push('resources')
      if (ctrl.counts.reports) sections.push('reports')
      ctrl.sections = sections

      ctrl.isEmpty = !ctrl.archived.length && !_.some(ctrl.counts)
      ctrl.stats = getStats()
      ctrl.filters = [
        { value: 'all', label: 'All', count: _.sum(_.values(ctrl.counts)) },
      ].concat(
        _.map(sections, function(section) {
          return {
            value: section,
            label: FILTER_LABEL[section],
            count: ctrl.counts[section],
          }
        })
      )
      if (ctrl.filter !== 'all' && !_.includes(sections, ctrl.filter)) {
        setFilter('all')
      }
    }

    function getStats() {
      var counts = ctrl.counts
      var segments = _.compact([
        counts.surveys && glUtils.countLabel(counts.surveys, 'survey'),
        counts.trackers && glUtils.countLabel(counts.trackers, 'tracker'),
        counts.resources && glUtils.countLabel(counts.resources, 'resource'),
        counts.reports && glUtils.countLabel(counts.reports, 'report'),
      ])
      if (ctrl.isEmpty) segments.push('Empty project')
      var responses = _.sumBy(
        ctrl.surveys.concat(ctrl.archived),
        'responseCount'
      )
      segments.push(
        responses
          ? glUtils.countLabel(responses, 'response')
          : 'no responses yet'
      )
      return segments.join(' · ')
    }

    function setFilter(filter) {
      useFilter(filter)
      $state.go(
        '.',
        { filter: filter === 'all' ? null : filter },
        { location: 'replace' }
      )
    }

    function useFilter(filter) {
      ctrl.filter = filter
      setLimit()
    }

    function setLimit() {
      ctrl.limit = ctrl.filter === 'all' ? CAP[ctrl.view] : undefined
    }

    function capClass(section) {
      if (ctrl.filter !== 'all') return ''
      var count = ctrl.counts[section]
      if (ctrl.view === 'list') return count > CAP.list ? '-overflow' : ''
      return '-capped -count-' + Math.min(count, CAP.card + 1)
    }

    function readSort() {
      var stored = prefs.get(sortPrefKey, { user: true })
      return _.some(ctrl.sortOptions, { value: stored })
        ? stored
        : projectSortService.DEFAULT
    }

    function setSort(value) {
      if (value === ctrl.sort) return
      ctrl.sort = value
      order()
      prefs.set(sortPrefKey, value, { user: true })
    }

    function readView() {
      var stored = prefs.get(viewPrefKey, { user: true })
      return _.includes(VIEWS, stored) ? stored : 'card'
    }

    function setView(value) {
      if (value === ctrl.view) return
      useView(value)
      setLimit()
      prefs.set(viewPrefKey, value, { user: true })
    }

    function useView(view) {
      ctrl.view = view
      ctrl.layout = view === 'list' ? 'row' : 'card'
    }

    function setImageStyle(imageUrl) {
      var url = cloudinaryService.resize(imageUrl, 160)
      ctrl.imageStyle = url && { backgroundImage: 'url(' + url + ')' }
    }

    function newSurvey() {
      var template = [
        '<gl-dialog class="new-survey-dialog__dialog">',
        '<new-survey-dialog ',
        'on-select="dialog.close($route)" ',
        'on-close="dialog.cancel()" ',
        '/>',
        '</gl-dialog>',
      ]
      glDialog
        .show({
          template: template.join(''),
          clickOutsideToClose: true,
          escapeToClose: true,
        })
        .then(create)
    }

    function create(route) {
      glAnalytics.track('surveys', 'new-survey-' + route, ctrl.project.id)
      accountService
        .promptUpgrade({
          context: 'more-surveys',
          bypassCondition: featureService.canCreateSurvey(),
        })
        .then(function() {
          createNewSurvey(route)
        })
    }

    function createNewSurvey(route) {
      if (!uacService.canManageSurveys(true)) return
      if (route === 'template') {
        $state.go('kits', { projectId: ctrl.project.id })
        return
      }
      $state.go('survey', {
        projectId: ctrl.project.id,
        surveyId: 'new',
        tab: 'editor',
        mode: route === 'ai' || route === 'upload' ? 'ai' : null,
        picker: route === 'copy' ? 'import-from' : null,
      })
    }

    function openSurvey(survey) {
      if (ctrl.project.isArchived) return
      $state.go('survey', surveyService.getOpenParams(survey))
    }

    function editProject() {
      if (!uacService.canManageProjects(true)) return
      projectService.edit(ctrl.project)
    }

    function archive(survey) {
      if (!uacService.canManageSurveys(true)) return
      var message =
        survey.activeChannelCount > 0
          ? 'Archiving this survey will turn off all live channels and people will no ' +
            'longer be able to respond to this survey. Do you still wish to archive it?'
          : 'Are you sure you want to archive this survey?'
      glDialog
        .confirm('Archive Survey', message)
        .then(function() {
          return channelService.disableSurveyChannels(
            survey.id,
            ctrl.subscriber.id
          )
        })
        .then(function() {
          survey.activeChannelCount = 0
        })
        .then(function() {
          _.remove(ctrl.surveys, survey)
          ctrl.archived.unshift(survey)
          surveyServiceNext.archive(survey).catch(function(err) {
            glToast.show('Error archiving survey')
            _.remove(ctrl.archived, survey)
            ctrl.surveys.unshift(survey) // KISS: it wont return to the exact original position
            order()
            throw err
          })
          order()
        })
        .catch(function() {
          glToast.show('Error archiving survey')
        })
    }

    function unArchive(survey) {
      if (ctrl.project.isArchived) return
      if (!uacService.canManageSurveys(true)) return
      glDialog
        .confirm(
          'Un-Archive Survey',
          'Are you sure you want to un-archive this survey?'
        )
        .then(function() {
          _.remove(ctrl.archived, survey)
          ctrl.surveys.unshift(survey)
          surveyServiceNext.unArchive(survey).catch(function(err) {
            glToast.show('Error archiving survey')
            _.remove(ctrl.surveys, survey)
            ctrl.archived.unshift(survey)
            order()
            throw err
          })
          order()
        })
    }

    function clone(survey) {
      accountService
        .promptUpgrade({
          bypassCondition:
            featureService.canCloneSurveys() || userService.isSSR(),
          context: 'clone-survey',
        })
        .then(function() {
          if (!uacService.canManageSurveys(true)) return
          projectService
            .pick({
              headerTitle: 'Duplicate To Project',
            })
            .then(function(selection) {
              glAnalytics.track('surveys', 'clone-from-survey', survey.id)
              var projectId = selection.project.id
              $state.go('survey', {
                projectId: projectId,
                cloneSurveyId: survey.id,
                surveyId: 'new',
              })
            })
        })
    }

    function move(survey) {
      if (!uacService.canManageSurveys(true)) return
      var currentProjectId = survey.projectId
      projectService
        .pick({
          headerTitle: 'Move To Project',
          hideProjectId: currentProjectId,
        })
        .then(function(selection) {
          survey.projectId = selection.project.id
          if (survey.isArchived) {
            _.remove(ctrl.archived, survey)
          } else {
            _.remove(ctrl.surveys, survey)
          }
          surveyServiceNext
            .changeProject(survey.id, survey.projectId)
            .then(function() {
              glToast.show('Survey has been moved')
            })
            .catch(function() {
              survey.projectId = currentProjectId
              if (survey.isArchived) {
                ctrl.archived.unshift(survey)
              } else {
                ctrl.surveys.unshift(survey)
              }
              order()
              glToast.show('Error moving survey')
            })
        })
    }

    function addResource() {
      if (!uacService.canManageProjects(true)) return
      projectResourceService.showEditor(ctrl.id).then(order)
    }

    function editResource(resource) {
      projectResourceService.showEditor(ctrl.id, resource).then(order)
    }

    function deleteResource(resource) {
      resource.isRemoved = true
      order()
      projectResourceService.save(resource).catch(function(error) {
        console.error(error)
        glToast.show('There was an error removing this resource.')
      })
    }

    function order() {
      ctrl.surveys = sortBy(ctrl.surveys, SURVEY_FIELDS)
      ctrl.archived = sortBy(ctrl.archived, SURVEY_FIELDS)
      ctrl.trackers = sortBy(ctrl.trackers, ITEM_FIELDS)
      ctrl.resources = sortBy(getResources(), ITEM_FIELDS)
      ctrl.reports = sortBy(ctrl.reports, ITEM_FIELDS)
    }

    function sortBy(items, fields) {
      return projectSortService.sort(items, ctrl.sort, fields)
    }

    function showTrackerEditor(tracker) {
      projectTrackerService
        .showEditor(tracker, ctrl.project.id)
        .then(function(saved) {
          var i = _.findIndex(ctrl.trackers, { id: saved.id })
          if (i >= 0) {
            ctrl.trackers.splice(i, 1, saved)
          } else {
            ctrl.trackers.push(saved)
          }
          order()
        })
    }
  }
})()
